import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import type { MitConsentDetailDTO } from '../../core/models';
import { MIT_CONSENT_TYPE_LABELS, MIT_LIMIT_ROWS, MitLimitRow, mitLimitValue } from '../../services/mit.service';

/** Evidencia de un consentimiento en solo lectura, para el drawer del detalle del mandato. */
@Component({
  selector: 'app-mit-consent-read',
  templateUrl: './mit-consent-read.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterLink, TooltipModule]
})
export class MitConsentReadComponent {
  consent = input.required<MitConsentDetailDTO>();

  private toastr = inject(ToastrService);
  private auth = inject(AuthService);

  readonly canReadTransactions = this.auth.hasRole('MIT_TRANSACTION_READ');
  readonly limitRows = MIT_LIMIT_ROWS;

  typeLabel = computed(() => {
    const type = this.consent().type;
    return type ? MIT_CONSENT_TYPE_LABELS[type] ?? type : '—';
  });

  deviceRows = computed(() =>
    Object.entries(this.consent().deviceDetails ?? {}).map(([key, value]) => ({
      key,
      value: value == null ? '—' : typeof value === 'object' ? JSON.stringify(value) : String(value)
    }))
  );

  limitValue(row: MitLimitRow): string {
    return mitLimitValue(row, this.consent().limits);
  }

  copy(value: string | null | undefined, label: string): void {
    if (!value) return;
    navigator.clipboard.writeText(value).then(() => this.toastr.success(`${label} copiado`));
  }
}
